import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {LoginApiService} from '../services/api/login/login-api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ArmSessionService} from '../services/common/arm-session/arm-session.service';
import {SessionService} from 'ac-infra';
import {UserDataService} from '../services/common/user-data/user-data.service';

export interface LoginCredentials {
  username: string;
  password: string;
}


export interface ArmSession {
  userName?: string;
  roles?: [string];
  roleName?: string;
  locked: boolean;
  inactivityPeriod: number;
  sessionTimeout?: number;
  sessionStartTime?: number;
  type?: string;
}

@Component({
  selector: 'arm-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

  constructor(private userDataService: UserDataService, private infraSessionService: SessionService,
              private loginApiService: LoginApiService,
              private activatedRoute: ActivatedRoute,
              private router: Router, private armSessionService: ArmSessionService) {
  }

  credentials: LoginCredentials;
  hidePassword = true;
  errorMessage: string = null;
  isAzureEnabled: boolean;

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.code && params.state) {
   //     this.loaderService.show();
        this.loginWithMicrosoft(params.code, params.state).then(() => {
   //       this.loaderService.hide();
        });
      }
    });
    const session: ArmSession = this.infraSessionService.activeSession;
    const isLocked = session ? session.locked : false;
    const azureData = this.activatedRoute.snapshot.data.azureData;
    this.isAzureEnabled = azureData ? azureData.enabled : false;

    this.credentials = {
      username: isLocked ? session.userName : '',
      password: undefined
    };
  }

  login(): void {
    this.loginApiService.login(this.credentials.username, this.credentials.password).then((userDetails) => {
      if (this.isUnlockState()) {
        this.unlockSession();
      } else {
        this.startSession(userDetails);
      }
      this.router.navigateByUrl('');
    }).catch(error => {
      this.errorMessage = this.generateErrorMessage(error);
    });
  }

  navigateToMicrosoftLogin(): void {
    this.loginApiService.loginWithMicrosoft().then((res) => {
      sessionStorage.setItem('token_state', res.tokenState);
      sessionStorage.setItem('token_nonce', res.tokenNonce);

      window.location = res.redirectUrl;
    }).catch(error => {
      this.errorMessage = this.generateErrorMessage(error);
    });
  }

  onKeyPress = (event: KeyboardEvent) => {
    if (event.which === 13) {
      event.stopPropagation();
      event.preventDefault();
      this.login();
    }
  }

  private startSession(userDetails): void {
    this.infraSessionService.endSession();
    const obj: ArmSession = {
      locked: false,
      inactivityPeriod: userDetails?.inactivityPeriod,
      sessionTimeout: userDetails.sessionTimeout * 60,
      roleName: userDetails?.roleName,
      type: userDetails?.type
    };
    this.userDataService.setData(userDetails);
    this.infraSessionService.startSession(obj);
  }

  private loginWithMicrosoft(code, state): any {
    const azureAuthenticationRequest = {
      authorizationCode: code,
      tokenResponseState: state,
      tokenRequestState: sessionStorage.getItem('token_state'),
      tokenRequestNonce: sessionStorage.getItem('token_nonce'),
      authenticationType: 'AUTHORIZATION_CODE'
    };

    return this.loginApiService.getTokenFromAzureAuthCode(azureAuthenticationRequest).then((userDetails) => {
      this.startSession(userDetails);
      this.armSessionService.startSession(userDetails);
      this.router.navigateByUrl('');
    }).catch(error => {
      this.errorMessage = this.generateErrorMessage(error);
    });
  }

  private isUnlockState(): any {
/*    return this.sessionService.activeSession && this.sessionService.activeSession.locked &&
      this.sessionService.activeSession.credentials === btoa(`${this.credentials.username}:${this.credentials.password}`);*/
  }

  private unlockSession(): void {
/*    this.sessionService.unlockSession();*/
  }

  private generateErrorMessage(error): any {
    const generalErrorMessage = 'Something went wrong, please try again later';

    return (error && error.error && error.error.description)
        ? error.error.description : generalErrorMessage;
  }
}
